import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'
import moment from 'moment'

import {
  FETCH_PARAMETERS_REQUEST,
  FETCH_PARAMETERS_SUCCESS,
  FETCH_PARAMETERS_ERROR,
  SAVE_PARAMETERS_REQUEST,
  SAVE_PARAMETERS_SUCCESS,
  SAVE_PARAMETERS_ERROR,
  RESET_ADJUST_BY_STORE,
} from 'actionTypes'


export const reset = ()=> (dispatch)=> {
  dispatch(resetAdjustByStore());
}

// Ação para buscar os parâmetros do novo endpoint
export const fetchAdjustByStoreRequest = (token, branchRegion, dsBranchRegion) => (dispatch) => {
  dispatch(fetchAdjustByStore());
  const request = {
    branchRegion,
    dsBranchRegion
  };

  if(branchRegion) {
    request.branchRegion = branchRegion
  }
  
  return new Api(token, dispatch)
    .get(API_URL.MENU_PUNCTUAL_ADJUST_BY_STORE_PARAMETERS_FIND, request)
    .then(dispatch(showSpinner()))
    .then((response) => {
      if (response && response.cdStatus === 200) {
        const storeData = response.data.punctualAdjustParamsBranchsModels.find(
          (branch) => branch.branchRegion === branchRegion && branch.dsBranchRegion === dsBranchRegion
        );
        dispatch(fetchAdjustByStoreSuccess({
          ...response.data,
          storeData
        }));

        dispatch(hideSpinner());
      } else {
        dispatch(fetchAdjustByStoreError(response));
        dispatch(hideSpinner());
      }
    })
    .catch((error) => {
      dispatch(fetchAdjustByStoreError(error));
      dispatch(hideSpinner());
    });
}

export const resetAdjustByStore = () =>({
  type: RESET_ADJUST_BY_STORE,
})

export const fetchAdjustByStore = () => ({
  type: FETCH_PARAMETERS_REQUEST,
})

export const fetchAdjustByStoreSuccess = (data) => ({
  type: FETCH_PARAMETERS_SUCCESS,
  payload: applyDoubleInMoney(data),
})

export const fetchAdjustByStoreError = (error) => ({
  type: FETCH_PARAMETERS_ERROR,
  payload: error,
})

// Ação para salvar os parâmetros no novo endpoint
export const updateAdjustByStore = (token, data) => (dispatch) => {
  dispatch(updateAdjustByStoreRequest())

  const args = {...applyDoubleInMoney(data)}

  return new Api(token, dispatch)
    .post(API_URL.MENU_PUNCTUAL_ADJUST_BY_STORE_PARAMETERS_SAVE, {
      ...args,
      cdLdap:data.cdLdap,
      dsLdap : data.dsLdap 
    })
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(updateAdjustByStoreSuccess(response.data))
      dispatch(hideSpinner())
      
      return response
    })
    .catch((error) => {
      dispatch(updateAdjustByStoreError(error.fields))
      dispatch(hideSpinner())
            
      return error.fields
    })
}

export const updateAdjustByStoreRequest = () => ({
  type: SAVE_PARAMETERS_REQUEST,
})

export const updateAdjustByStoreSuccess = (data) => ({
  type: SAVE_PARAMETERS_SUCCESS,
  payload: applyDoubleInMoney(data),
})

export const updateAdjustByStoreError = (error) => ({
  type: SAVE_PARAMETERS_ERROR,
  payload: error,
})


export const fetchRequest = (token) => (dispatch) => {
  dispatch(fetchParametersRequest())

  return new Api(token, dispatch)
    .get(API_URL.MENU_PUNCTUAL_ADJUST_PARAMETERS_GET, {
      dsYear: moment().format('YYYY'),
    })
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchRequestSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchRequestError(error))
      dispatch(hideSpinner())
    })
}

export const fetchParametersRequest = () => ({
  type: FETCH_PARAMETERS_REQUEST,
})

export const fetchRequestSuccess = (data) => {
  const allParameters = applyDoubleInMoney(data)
  return {
    type: FETCH_PARAMETERS_SUCCESS,
    payload: allParameters,
  }
}

export const fetchRequestError = (error) => ({
  type: FETCH_PARAMETERS_ERROR,
  payload: error,
})

export const updateParameters = (token, data) => (dispatch) => {
  dispatch(updateParametersRequest())

  const args = applyDoubleInMoney(data)

  return new Api(token, dispatch)
    .post(API_URL.MENU_PUNCTUAL_ADJUST_PARAMETERS_SAVE, args)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(updateParametersSuccess(response.data))
      dispatch(hideSpinner())

      return response
    })
    .catch((error) => {
      dispatch(updateParametersError(error.fields))
      dispatch(hideSpinner())
      return error.fields
    })
}

export const updateParametersRequest = () => ({
  type: SAVE_PARAMETERS_REQUEST,
})

export const updateParametersSuccess = (data) => ({
  type: SAVE_PARAMETERS_SUCCESS,
  payload: applyDoubleInMoney(data),
})

export const updateParametersError = (error) => ({
  type: SAVE_PARAMETERS_ERROR,
  payload: error,
})

const applyDoubleInMoney = (data) => {
  const moneyFields = ['valueAdjust', 'valueLimit']

  moneyFields.map((field) => {
    if (data[field]) {
      data[field] = Number(data[field]).toFixed(2)
    }
  })

  const allParameters = {
    idSPAP: data.idSPAP,
    dsYear: data.dsYear,
    qqChanges: data.qqChanges,
    qqDay: data.qqDay,
    adjustStockSystem: data.adjustStockSystem,
    valueAdjust: data.valueAdjust,
    timoutLatency: data.timoutLatency,
    qqStockLimit: data.qqStockLimit,
    valueLimit: data.valueLimit,
    inAVS: data.inAVS,
    inTop2500: data.inTop2500,
    inMDH: data.inMDH,
    inPAR: data.inPAR,
    inVEF: data.inVEF,
    papBranchs: data.papBranchs
  }

  return allParameters
}
